import { Container, TextField, Button, Grid } from "@mui/material";
import BackIcon from "@mui/icons-material/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import * as queryString from "query-string";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//multiselect
import MultiSelect from "react-multi-select-component";
import { useHistory } from "react-router-dom";
//list items
import CustomList from "../../components/List/CustomList";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { useTranslation } from "react-i18next";
import { getEquipmentDetailById, getEquipmentReportGroupById, resetEqGroup, editEquipmentGroupInfo, resetEditedGroupInfo } from "../../store/actions/EquipmentAction";
import Autocomplete from "@mui/material/Autocomplete";

export default function AddEquipmentToGroup() {
    let [data, setData] = useState([]);
    const dispatch = useDispatch();
    let [allGroup, setAllGroup] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const { t } = useTranslation("translation");

    const { equipmentAgainstId, eqReportList, eqReportAgainstId, equipmentGroupInfo } = useSelector(({ equipment }) => equipment);

    useEffect(() => {
        LoadHandler();
    }, []);

    useEffect(() => {
        if (equipmentAgainstId?.resultObject) {
            setData(equipmentAgainstId.resultObject);
            setPageLoaded(true);
        }
    }, [equipmentAgainstId]);

    useEffect(() => {
        if (eqReportList?.resultObject) {
            setAllGroup(
                Object.values(eqReportList.resultObject).map((item,index) => ({
                    label: item.name,
                    value: item.id,
                    name: item.name
                }))
            );
            dispatch(getEquipmentReportGroupById(queryString.parse(window.location.search).id));
        }
    }, [eqReportList]);

    useEffect(() => {
        if (eqReportAgainstId?.resultObject) {
            const result = Object.values(eqReportAgainstId.resultObject).map((item,index) => ({
                label: item.name,
                value: item.id,
                name: item.name
            }));
            setSelected(result);
            dispatch(resetEqGroup());
        }
    }, [eqReportAgainstId]);

    useEffect(() => {
        if (equipmentGroupInfo?.data) {
            dispatch(resetEditedGroupInfo());
            LoadHandler();
        }
    }, [equipmentGroupInfo]);

    const LoadHandler = () => {
        let payload = {
            id: queryString.parse(window.location.search).id,
            eqGroup: true,
        };
        dispatch(getEquipmentDetailById(payload));
    };

    //add data
    const AddHandler = () => {
        const data = selected.map((item) => item.value);
        let payload = {
            id: queryString.parse(window.location.search).id,
            data: data,
        };
        dispatch(editEquipmentGroupInfo(payload));
    };

    const history = useHistory();
    const TurnBack = () => {
        history.push({ pathname: "/equipment/" });
    };

    const [selected, setSelected] = useState([]);
    //override strings in multiselect
    const stringTR = {
        selectSomeItems: t("SelectSomeItems"),
        allItemsAreSelected: t("AllItemsAreSelected"),
        selectAll: t("SelectAll"),
        search: t("Search"),
    };

    return (
        <Container id="eg_Container" maxWidth="md">
            <h1>{t("EquipmentInformation")}</h1>
            {pageLoaded === true ? (
                <Grid id="eg_Grid" container spacing={3}>
                    <Grid id="eg_Grid_1" item xs={12} sm={6} md={3}>
                        <TextField
                            id="eg_TextField"
                            label={t("EquipmentCode")}
                            defaultValue={data.code}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid id="eg_Grid_2" item xs={12} sm={6} md={3}>
                        <TextField
                            id="eg_TextField_1"
                            label={t("EquipmentName")}
                            defaultValue={data.name}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid id="eg_Grid_3" item xs={12} sm={6} md={3}>
                        <TextField
                            id="eg_TextField_2"
                            label={t("EquipmentType")}
                            defaultValue={data.typeName}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid id="eg_Grid_4" item xs={12} sm={6} md={3}>
                        <TextField
                            id="eg_TextField_3"
                            label={t("FieldName")}
                            defaultValue={data.areaName}
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid id="eg_Grid_5" item xs={6} sm={6}>
                        <h4>{t("EquipmentGroups")}</h4>
                        <Autocomplete
                            multiple
                            id="eg_Autocomplete_1"
                            options={allGroup}
                            limitTags={5}
                            value={allGroup.filter((item) => Object.values(selected).map((item) => {return item.name}).includes(item.name))}
                            disableCloseOnSelect={true}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params} margin="normal" label={t("EquipmentGroups")} variant="outlined" id="aug_table_TextField_0" />}
                            onChange={(event, newValue) => {
                                setSelected(newValue)
                            }}
                            renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
                            size={"normal"}
                        />
                    </Grid>
                    <Grid id="eg_Grid_6" item xs={6} sm={6}>
                        <pre style={{ marginTop: 25 }}>
                            <CustomList id="eg_cl" dense={true} listItems={selected} name="list1"/>
                        </pre>
                    </Grid>
                    <Grid id="eg_Grid_7" item xs={6} sm={6} style={{ textAlign: "left" }}>
                        <Button
                            id="eg_Button"
                            onClick={TurnBack}
                            variant="contained"
                            endIcon={<BackIcon id="eg_BackIcon" />}
                            style={{ marginRight: 15 }}>
                            {t("TurnBack")}
                        </Button>
                        <Button id="eg_Button_1" onClick={() => AddHandler()} variant="contained" color="primary" endIcon={<CheckIcon />}>
                            {t("Save")}
                        </Button>
                    </Grid>
                </Grid>
            ) : null}
            <LoadingBackdrop id="eg_lbd" />
        </Container>
    );
}
